export default __webpack_public_path__ + "static/media/topCars.d261ca35.jpg";